<template>
    <div class="container -mt-30p">
        <div class="row">
            <div class="col d-flex justify-content-center pt-4 pb-5">
                <h1 class="text-center">Completează datele<br/>pentru conectare:</h1>
            </div>
        </div>
        <form @submit.prevent="" class="login mx-auto">
            <div class="form-row pb-2">
                <div class="form-group w-100 mx-auto">
                    <div class="styled_select">
                        <div class="select__wrapper">
                            <label :class = "{'label-error' : (!$v.locationId.required && $v.locationId.$error)}" for="storeUser" v-if="app_type == 'direct'">Nume locație</label>
                            <label :class = "{'label-error' : (!$v.locationId.required && $v.locationId.$error)}" for="storeUser" v-else>Oraș</label>
                            <select v-model="locationId" class="form-control select-dropdown mb-1 list_position login_input" id="storeUser" :class = "{'border-error' : (!$v.locationId.required && $v.locationId.$error)}">
                                <option v-for="(location) in dropDownLocations" :key="location.id" :value="location.id">
                                    {{ location.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <p class="error" v-if="!$v.locationId.required && $v.locationId.$error">Selectează o locație.</p>
                </div>
            </div>
            <div class="form-row pb-4">
                <div class="form-group w-100 mx-auto mt-3">
                    <label :class = "{'label-error' : (!$v.locationId.required && $v.locationId.$error)}" for="storePassword">Parolă</label>
                    <input v-model="password" autocomplete="off" class="form-control login_input" type="password" id="storePassword"
                    :class="[{'border-error' : (!$v.password.required && $v.password.$error) || loginMessage === 'Invalid login'},'border-ok']" />
                    <p class="error" v-if="!$v.password.required && $v.password.$error">Te rugăm sa introduci parola.</p>
                    <p class="error" v-if="loginMessage === 'Invalid login'">Parola introdusă este greșită.</p>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group mx-auto mt-4 mb-3 ">
                    <!-- <button type="submit" class="button button--grey mx-auto">Conectează-te</button> -->
                    <button type="button" @click="login()" class="button button--dark mx-auto">Conectează-te</button>
                    <p class="error mt-4 error--version" v-if="loginMessage === 'Folosesti o versiune veche a aplicatiei. Te rugam sa actualizezi.' ">Folosești o versiune veche a aplicației. Te rugăm să actualizezi sau să reîmprospătezi browserul.</p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "Login",
    data() {
        return {
            locationId: '',
            password: null,
            app_type: typeof process.env.VUE_APP_APP_TYPE != 'undefined' ? process.env.VUE_APP_APP_TYPE : 'direct'
        }
    },
    validations: {
        locationId: {
            required
        },
        password: {
            required,
        }
    },
    computed: mapGetters(['dropDownLocations', 'loginMessage']),

    methods: {
        login() {
            this.$v.$touch();

            if (!this.$v.$anyError) {
                var username = this.locationId,
                    password = this.password;
                const payload = {username, password};
                this.checkLogin(payload);
            }
        },
        ...mapActions({
            'checkLogin': 'checkLogin',
        })
    },
    mounted() {
        const check = this.$store.getters.isAuthenticated; 
        if (check) {
            this.$store.dispatch('Authenticated')
        }
        else {
            console.log('not authenticated');
            var token = this.$route.query.token;
            console.log(token);
            if(typeof token != 'undefined') {
                // make request on control api with received token
                // get username & password
                var username = this.locationId,
                    password = this.password;
                const payload = {username, password};
                this.checkLogin(payload);
            }
            // if is set token param in url make request on the control tower api to get credentials/validate token
        }
    }
};
</script>
